import { fetchImageAsBlob, getImageUrl } from '../images';

// Transform API data to match the app's data structure
// Now async to fetch images as blobs to bypass CORS/403 issues
export const transformServiceData = async (serviceTypes, services) => {
  console.log('Transforming service data...', { serviceTypesCount: serviceTypes.length, servicesCount: services.length });
  
  if (!serviceTypes || serviceTypes.length === 0) {
    console.warn('No service types provided to transformServiceData');
    return [];
  }
  
  if (!services || services.length === 0) {
    console.warn('No services provided to transformServiceData');
    return [];
  }
  
  try {
    const transformedTypes = await Promise.all(
      serviceTypes.map(async (type) => {
      // Fetch type image as blob
      let typeImageUrl = null;
      try {
        typeImageUrl = await fetchImageAsBlob(type.image);
        console.log(`Fetched blob for type ${type.name}:`, typeImageUrl);
      } catch (error) {
        console.warn(`Failed to fetch blob for type ${type.name}, using direct URL:`, error);
        typeImageUrl = getImageUrl(type.image);
      }

      // Find all services that belong to this type and fetch their images
      const typeServices = await Promise.all(
        services
          .filter((service) => service.type === type.id)
          .map(async (service) => {
            let serviceImageUrl = null;
            try {
              serviceImageUrl = await fetchImageAsBlob(service.image);
            } catch (error) {
              console.warn(`Failed to fetch blob for service ${service.name}, using direct URL:`, error);
              serviceImageUrl = getImageUrl(service.image);
            }
            return {
              name: service.name,
              description: service.description,
              image: serviceImageUrl || getImageUrl(service.image),
            };
          })
      );

      const transformed = {
        title: type.name,
        image: typeImageUrl || getImageUrl(type.image),
        description: type.description,
        services: typeServices,
        url: `/services/${type.name.toLowerCase().replace(/\s+/g, '-')}`,
      };

        console.log(`Transformed type: ${type.name} with ${typeServices.length} services`);
        return transformed;
      })
    );

    console.log('Transformation complete:', transformedTypes);
    console.log('Transformation complete - count:', transformedTypes.length);
    return transformedTypes;
  } catch (error) {
    console.error('Error in transformServiceData:', error);
    console.error('Error details:', error);
    throw error;
  }
};

